module.exports = __webpack_public_path__ + "img/cup.8b15baef.png";